<template>
    <v-container fluid>
        <v-row>
            <v-col>
                <v-tabs>
                    <v-tab>Records</v-tab>
                    <v-tab-item>
                        <audit-records :filter="auditFilter" />
                    </v-tab-item>
                    <v-tab>Manage CARs</v-tab>
                    <v-tab-item>
                        <v-card>
                            <corrective-action-requests :filter="correctiveActionRequestFilter" />
                        </v-card>
                    </v-tab-item>
                    <v-tab>Previous Audit</v-tab>
                    <v-tab-item>
                        <audit v-if="previousAuditId" :audit-id="previousAuditId" />
                        <v-card v-if="!previousAuditId">
                            <v-card-text>
                                You have not previously audited this member
                            </v-card-text>
                        </v-card>
                    </v-tab-item>
                    <v-tab>Upload Report</v-tab>
                    <v-tab-item>
                        <file-upload :value="reportFileId" @input="onFileUploaded" />
                    </v-tab-item>
                </v-tabs>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    import axios from 'axios'
    import securityService from '../services/securityService'

    export default {
        components: {
            auditRecords: () => import('../components/AuditRecords'),
            correctiveActionRequests: () => import('../tables/CorrectiveActionRequestsTable'),
            audit: () => import('../editViews/Audit'),
            fileUpload: () => import('../components/FileUpload')
        },

        data() {
            return {
                auditId: null,
                reportFileId: null,
                previousAuditId: null,
                auditorId: null,
                isLoading: false
            }
        },

        async mounted() {
            this.auditId = this.$route.params.id;
            this.auditorId = securityService.getAuditorId();
            this.getReportFileId();

            var auditResponse = await axios.get('/api/Audits/PreviousAudit/' + this.auditId);
            this.previousAuditId = auditResponse.data.id;
        },

        methods: {
            async getReportFileId() {
                var response = await axios.get('/api/Audits/' + this.auditId);
                this.reportFileId = response.data.reportFileId;
            },
            async onFileUploaded(fileId) {
                var auditResponse = await axios.get('/api/Audits/' + this.auditId);
                var audit = auditResponse.data;
                audit.reportFileId = fileId;
                await axios.put('/api/Audits/', audit);
            }
        },

        computed: {
            correctiveActionRequestFilter() {
                var filter = { auditId: this.auditId };
                if (this.auditorId) {
                    filter.auditorId = this.auditorId;
                }
                return filter;
            },
            auditFilter() {
                var filter = { id: this.auditId };
                if (this.auditorId) {
                    filter.auditorId = this.auditorId;
                }
                return filter;
            }
        }
    };
</script>
